import { render, staticRenderFns } from "./CreateCompanyClient.vue?vue&type=template&id=335771f5&scoped=true"
import script from "./CreateCompanyClient.vue?vue&type=script&lang=js"
export * from "./CreateCompanyClient.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyClient.vue?vue&type=style&index=0&id=335771f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335771f5",
  null
  
)

export default component.exports